var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['subscription-bar', _vm.backgroundClass]},[_c('div',{staticClass:"subscription-bar-wrapper md:container mb-[40px] md:mb-[80px] px-5 lg:px-0"},[_c('LatestNews'),_vm._v(" "),_c('div',{staticClass:"flex flex-col md:w-2/5"},[_c('EmailSubscription',{staticClass:"mb-[40px] md:mb-[80px]"}),_vm._v(" "),_c('SocialMedia')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }